let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dpBH6")).then(() => parcelRequire('7Prkm'));